<template>
  <b-row class="row-Two">
    <b-container>
      <div class="container dos">
        <h4 class="title">{{ title }}</h4>
      </div>

      <div class="container tres">
        <b-row class="row-select">
          <b-col cols="6" class="select-div">
            <b-form-select
              class="select"
              v-model="selected"
              :options="options"
            ></b-form-select>
          </b-col>

          <b-col cols="6" class="select-div-two">
            <b-form-select
              class="select-two"
              v-model="selectedRight"
              :options="optionsRight"
            ></b-form-select>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </b-row>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      title: "Para comenzar selecciona 2 instituciones que quieras comparar",
      selected: null,
      options: [
        {
          value: null,
          text: "- Selecciona una opción -",
        },
      ],
      selectedRight: null,
      optionsRight: [
        {
          value: null,
          text: "- Selecciona una opción -",
        },
      ],
    }
  },
  methods: {
    getServices: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/public_list`
        );

        const listedServices = res.data.map((i) => ({
          value: i.id,
          text: i.nombre,
        }));

        listedServices.unshift({
          value: null,
          text: "- Selecciona una opción -",
        });

        this.options = listedServices;
        this.optionsRight = listedServices;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getServices();
  },
  watch: {
    selected: function() {
      this.$store.commit("setService1", this.selected);
    },
    selectedRight: function() {
      this.$store.commit("setService2", this.selectedRight);
    },
  },
};
</script>
<style scoped>
.row {
  margin: 0;
  background: #052333;
  height: 140px;
}

.containerr {
  margin-top: 30px;
  margin-left: 35px;
}

.container {
  margin-top: 30px;
}

.ruta {
  color: #fff;
}

.span {
  color: #fff;
}

.row-Two {
  margin: 0;
  background: #e0e0e0;
  height: 140px;
}

.dos {
  margin-top: -5px;
}

.title {
  text-align: center;
  color: #052333;
}

.select-div {
  text-align: end;
}

.select {
  border: none;
  width: 280px;
  font-size: 16px;
  color: #052333;
  margin-left: -10px;
}

.row-select {
  background: #e0e0e0;
  height: 50px;
}

.select-two {
  border: none;
  width: 280px;
  font-size: 16px;
  color: #052333;
}

@media screen and (max-width: 768px) {
  .title {
    font-size: 14px;
  }

  .select {
    width: 200px;
    font-size: 12px;
  }

  .select-two {
    width: 200px;
    font-size: 12px;
  }
}

@media screen and (max-width: 510px) {
  .ruta {
    font-size: 16px;
  }

  .span {
    font-size: 10px;
  }
  .title {
    font-size: 11px;
  }

  .select {
    width: 150px;
    font-size: 10px;
  }

  .select-two {
    width: 150px;
    font-size: 10px;
  }
}

@media screen and (max-width: 399px) {
  .select {
    width: 110px;
    font-size: 9px;
  }

  .select-two {
    width: 110px;
    font-size: 9px;
  }
}
</style>
